import { HeaderContainer } from "./Header.styles";

export function Header() {
  return (
    <HeaderContainer>
        <h1>Lista de Tarefas</h1>
    </HeaderContainer>
  )
}